/** @jsx jsx */
import { AsyncIndicator, Colors } from '@zapier/design-system';
import { jsx } from '@emotion/core';
import { PAYPAL_BUTTON_ID } from '../constants';

const buttonCss = {
  alignItems: 'center',
  background: '#009cde',
  borderRadius: 4,
  color: Colors.white,
  display: 'flex',
  height: 49,
  justifyContent: 'center',
  position: 'relative',
  minWidth: 250,
} as const;

type Props = {
  /** show loading indicator */
  isLoading: boolean;
};

const PaypalButtonPlaceholder = (props: Props) => (
  <div css={buttonCss} id={PAYPAL_BUTTON_ID}>
    {props.isLoading && <AsyncIndicator color="inherit" />}
  </div>
);

export default PaypalButtonPlaceholder;
